/* eslint-disable unused-imports/no-unused-vars */
import { TFunction } from "next-i18next";
import { DrSmileUniversalFormLayoutProps } from "layouts/pages/DrSmileUniversalFormLayout";

import { PageContentProps } from "../content.types";

const pageContent = (
    //@ts-ignore
    t: TFunction,
    //@ts-ignore
    { locale }: PageContentProps
): DrSmileUniversalFormLayoutProps => {
    return {
        content: {
            title: t("universalForm:title"),
            teamTitle: t("universalForm:teamTitle"),
            teamDescription: t("universalForm:teamDescription"),
            bannerText: t("drSmile:bannerText"),
            bannerDisclaimer: t("drSmile:bannerDisclaimer"),
        },
    };
};

export default pageContent;
